import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import Errorable from '../lib/Errorable/';
import Loadable from '../lib/Loadable/';
import Schedule from 'containers/chat/Schedule';
import SearchingForAgent from 'containers/chat/SearchingForAgent';
import Thanks from 'containers/chat/Thanks';
import Chat from 'containers/chat/Chat';
import globalConfiguration from 'config';
import { CHAT_PART } from 'actions/chat';
import { UPLOAD_SINGLE } from 'actions/chat/fileUpload';
import autobind from 'autobind-decorator';
import { DirectLine, ConnectionStatus } from 'botframework-directlinejs';
import uuid from 'uuid';
import './styles/index.scss';

const configuration = globalConfiguration.chat;

const notificationConfigurationPropTypes = PropTypes.shape({
  title: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  vibrationPattern: PropTypes.arrayOf(PropTypes.number),
  badge: PropTypes.string,
  tag: PropTypes.string,
  icon: PropTypes.string,
  image: PropTypes.string,
  renotify: PropTypes.bool,
  requireInteraction: PropTypes.bool,
});

const queuePropertiesPropTypes = PropTypes.shape({
  queueID: PropTypes.number.isRequired,
  connectionTimeout: PropTypes.number,
  offerKeepWaiting: PropTypes.bool.isRequired,
  delayBeforeOfferingToKeepWaiting: PropTypes.number,
});

const validationResultPropTypes = PropTypes.shape({
  isOutOfSchedule: PropTypes.bool,
  chatRequestId: PropTypes.number,
  caseNumber: PropTypes.number,
});

const clientPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  userRenderHeader: PropTypes.string.isRequired,
});

@Errorable()
@Loadable({ size: 'medium' })
class ChatMain extends Component {
  static propTypes = {
    companionConfiguration: PropTypes.object,
    appWidth: PropTypes.number,
    fullscreen: PropTypes.bool,
    pendingNotifications: PropTypes.number,
    notificationsEnabled: PropTypes.bool.isRequired,
    notificationConfiguration: notificationConfigurationPropTypes,
    queueProperties: queuePropertiesPropTypes,
    validationResult: validationResultPropTypes,
    client: clientPropTypes,
    userFocus: PropTypes.bool.isRequired,
    assignEnvironmentFocusHandler: PropTypes.func,
    assignEnvironmentBlurHandler: PropTypes.func,
    headerHeight: PropTypes.number,
    appHeight: PropTypes.number.isRequired,
    started: PropTypes.bool.isRequired,
    botState: PropTypes.object,
    alreadyReceivedImages: PropTypes.arrayOf(PropTypes.number),
    ended: PropTypes.bool.isRequired,
    routing: PropTypes.bool.isRequired,
    chatting: PropTypes.bool.isRequired,
    connectionId: PropTypes.number,
    minimized: PropTypes.bool,
    hideSendButton: PropTypes.bool,
    hubStartedTime: PropTypes.object,
    routingAttempts: PropTypes.number,
    userTyping: PropTypes.bool.isRequired,
    tpClientInstanceUrl: PropTypes.string,
    botConfiguration: PropTypes.object.isRequired,
    offeredToKeepWaiting: PropTypes.bool.isRequired,
    pollingForAgentImagesEnabled: PropTypes.bool.isRequired,
    pollingForAgentImagesInterval: PropTypes.number,
    surveyTextHeader: PropTypes.string,
    delayBetweenRoutingAttempts: PropTypes.number,
    allowedWebRTCFeatures: PropTypes.array.isRequired,
    customSiteUrlHexEncoded: PropTypes.string,
    endAfterVideoClosed: PropTypes.bool,
    thankAndReload: PropTypes.bool,
    onOutOfSchedule: PropTypes.func.isRequired,
    onNetworkError: PropTypes.func.isRequired,
    onHubStarted: PropTypes.func.isRequired,
    onHubStartError: PropTypes.func.isRequired,
    onRoutingFail: PropTypes.func.isRequired,
    onRoutingSuccess: PropTypes.func.isRequired,
    onChatEnd: PropTypes.func.isRequired,
    onMessageSent: PropTypes.func.isRequired,
    onMessageReceived: PropTypes.func.isRequired,
    onInitError: PropTypes.func.isRequired,
    onUserTyping: PropTypes.func.isRequired,
    onUserNotTyping: PropTypes.func.isRequired,
    onSendMailTranscript: PropTypes.func.isRequired,
    onMailTranscriptSent: PropTypes.func.isRequired,
    onMailTranscriptError: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onBotEnd: PropTypes.func.isRequired,
    onWebRTCAgentSide: PropTypes.func.isRequired,
    onEndWebRTC: PropTypes.func.isRequired,
    onPollForAgentImages: PropTypes.func.isRequired,
    onStartHub: PropTypes.func.isRequired,
    onBotError: PropTypes.func.isRequired,
    onBotActivityPublished: PropTypes.func.isRequired,
    onBotActivityReceived: PropTypes.func.isRequired,
    onBotStatusChanged: PropTypes.func.isRequired,
    onSingleFileUpload: PropTypes.func.isRequired,
    onMinimize: PropTypes.func,
  };
  static PADDING = 20;
  static RECONNECT_ATTEMPTS = 12;
  static RECONNECT_INTERVAL = 5000;

  constructor(props) {
    super(props);

    this.state = {
      restartingBecauseOfDiscconect: false,
      reconnecting: false,
      reconnectAttempts: 0,
      reconnectingFailed: false
    };
  }

  get receivedMessageOptions() {
    return {
      companionConfiguration: this.props.companionConfiguration,
      notify: this.props.notificationsEnabled && !this.props.userFocus,
      pendingNotifications: this.props.pendingNotifications,
      notificationTitle: this.props.notificationConfiguration.title,
      notificationTitlePlural: this.props.notificationConfiguration.titlePlural,
      notificationOptions: { ...this.props.notificationConfiguration, title: undefined },
    };
  }
  focused() {
    if (this.lastNotification) {
      this.lastNotification.close();
    }
    return this.props.onFocus();
  }
  checkIfOutOfSchedule() {
    if (this.props.assignEnvironmentFocusHandler && this.props.assignEnvironmentBlurHandler) {
      this.props.assignEnvironmentFocusHandler(() => {
        if (
          this.props.minimized !== null && this.props.minimized !== undefined
          && !this.props.minimized
        ) {
          this.focused();
        }
      });
      this.props.assignEnvironmentBlurHandler(this.props.onBlur);
    }

    if (this.props.hubStarted && this.props.validationResult.isOutOfSchedule) {
      this.props.onOutOfSchedule();
      return true;
    }

    return false;
  }
  pollForAgentImages() {
    this.props.onPollForAgentImages(this.props.validationResult.caseNumber, this.props.alreadyReceivedImages)
      .then(() => this.pollForAgentImagesTimeout = setTimeout(
        this.pollForAgentImages.bind(this),
        this.props.pollingForAgentImagesInterval * 1000
      ));
  }
  @autobind
  reconnect() {
    console.debug('Reconnecting');
    window.setTimeout(() => {
      $.connection.hub.stop();
      this.chatInstance.privateScreenStatus = 'End';
      this.chatInstance = null;
      this.initializeChatInstance();
    }, ChatMain.RECONNECT_INTERVAL);
  }
  initializeChatInstance() {
    if (
      this.props.hubStarted && 
      !this.props.validationResult.isOutOfSchedule && 
      !this.props.ended && 
      !this.chatInstance && 
      !this.state.reconnectingFailed
    ) {
      console.debug('Initializing HUB');
      this.chatInstance = new Teleperformance.TPClient.ExternalTools.ChatV31(this.props.tpClientInstanceUrl);

      var that = this;

      this.chatInstance.Fn_Event_NetworkError = function (error) {
        if (this !== that.chatInstance) {
          return;
        }

        if (that.props.thankAndReload) {
          if (!that.state.restartingBecauseOfDiscconect) {
            that.setState({ restartingBecauseOfDiscconect: true });
          }
          return;
        }
        
        that.props.onNetworkError(that.props.surveyTextHeader, error);
        const reconnectAttempts = that.state.reconnectAttempts + 1;
        const reconnectingFailed = reconnectAttempts >= ChatMain.RECONNECT_ATTEMPTS;

        console.debug(`Reconnecting failed, attempt ${reconnectAttempts}`);
        that.setState({ reconnecting: true, reconnectAttempts, reconnectingFailed });

        if (!reconnectingFailed) {
          that.reconnect();
        } else {
          console.debug('Reconnecting failed definitively');
        }
      };

      this.chatInstance.Fn_Event_Hub_StartOk = () => {
        this.props.onHubStarted();
        if (this.props.pollingForAgentImagesEnabled) {
          this.pollForAgentImagesTimeout = setTimeout(
            this.pollForAgentImages.bind(this),
            this.props.pollingForAgentImagesInterval * 1000
          );
        }
      };
      this.chatInstance.Fn_Event_Hub_StartFail = this.props.onHubStartError;
      this.chatInstance.Fn_Encrypt_SimmetrycKeyWith_RSA = this.encryptSymmetricKey;
      this.chatInstance.Fn_EncryptMessageHub = this.encryptMessageHub;
      this.chatInstance.Fn_DecryptMessageHub = this.decryptMessageHub;
      this.chatInstance.Fn_Event_RoutingToAgentsFail = this.props.onRoutingFail({
        tryAgain: () => this.chatInstance.fnTryRoutingAgain(this.props.delayBetweenRoutingAttempts),
        abort: () => this.chatInstance.fnAbortRoutingChat(),
        timeoutInMinutes: this.props.queueProperties.connectionTimeout,
        offerKeepWaiting: this.props.queueProperties.offerKeepWaiting,
        delayBetweenRoutingAttempts: this.props.delayBetweenRoutingAttempts,
        delayBeforeOfferingToKeepWaiting: this.props.queueProperties.delayBeforeOfferingToKeepWaiting,
        offeredToKeepWaiting: () => this.props.offeredToKeepWaiting,
        startTime: () => this.props.hubStartedTime,
        routingAttempts: () => this.props.routingAttempts,
      });
      this.chatInstance.Fn_Event_RoutingToAgentsOK = connectionId => {
        if (this.state.reconnecting) {
          console.debug('Reconnecting ended successfully');
          this.setState({ reconnecting: false, reconnectAttempts: 0, reconnectingFailed: false });
        }

        this.props.onRoutingSuccess(
          this.chatInstance.DetectWebRTC_TECH_AgentSide.bind(this.chatInstance),
          this.props.queueProperties.queueID,
          this.props.allowedWebRTCFeatures,
          this.props.customSiteUrlHexEncoded,
          connectionId
        );
      };
      this.chatInstance.Fn_Event_ChatEnd = () => {
        this.props.onChatEnd(CHAT_PART.agent, this.props.surveyTextHeader);
        if (this.props.pollForAgentImagesTimeout) {
          clearTimeout(this.props.pollForAgentImagesTimeout);
        }
      };
      this.chatInstance.Fn_Event_Receive_Message = async (message, agentHeader) => {
        const ownCameraSnapshotMatch = /\[tpsouthcone_command_camera_own_snapshot\]/.exec(message);
        const switchOwnCameraMatch = /\[tpsouthcone_command_camera_own_switch\]/.exec(message);

        if (ownCameraSnapshotMatch) {
          const wrappedInstance = this.chat && this.chat.getWrappedInstance();
          const snapshot = wrappedInstance && wrappedInstance.ownVideoScreenSnapshot();
          if (snapshot) {
            try {
              const fileUploadAction = await this.props.onSingleFileUpload(
                this.props.validationResult.caseNumber,
                uuid(),
                'png',
                snapshot
              );

              if (fileUploadAction.type !== UPLOAD_SINGLE) {
                throw new Error();
              }
              
              this.sendMessageToAgent(`[tpclient_external_image:${fileUploadAction.guid}]`);
            } catch (error) {
              this.sendMessageToAgent('Hubo un error al intentar scanear');
            }
            
          } else {
            this.sendMessageToAgent('El video no está iniciado todavía, no se puede scanear');
          }
        }

        if (switchOwnCameraMatch) {
          const wrappedInstance = this.chat && this.chat.getWrappedInstance();
          if (wrappedInstance && wrappedInstance.switchOwnCamera()) {
            this.sendMessageToAgent('Se cambió la cámara');
          } else {
            this.sendMessageToAgent('Hubo un error cambiando la cámara');
          }
        }

        const messageAction = await this.props.onMessageReceived(
          this.receivedMessageOptions, 
          message, 
          agentHeader);

        this.lastNotification = messageAction.notification;

        if (messageAction.printed === true) {
          this.sendMessageToAgent('Se imprimió el archivo');
        } else if (messageAction.printed === false) {
          this.sendMessageToAgent('Hubo un error al imprimir el archivo');
        }
      };

      this.chatInstance.Fn_Event_UserMessageCallback = message => this.props.onMessageSent(message, this.props.client.userRenderHeader);
      this.chatInstance.Fn_Event_AgentIsTyping = this.props.onAgentTyping;
      this.chatInstance.Fn_Event_AgentNoTyping = this.props.onAgentNotTyping;
      this.chatInstance.Fn_CheckIfUserStillTyping = () => this.props.userTyping;
      this.chatInstance.Fn_Event_EmailTranscriptOk = this.props.onMailTranscriptSent;
      this.chatInstance.Fn_Event_EmailTranscriptFail = this.props.onMailTranscriptError;
      this.chatInstance.Fn_Event_WebRTCAgentSideFail = this.props.onWebRTCAgentSide.bind(null, false);
      this.chatInstance.Fn_Event_WebRTCAgentSideOK = this.props.onWebRTCAgentSide.bind(null, true);
      this.chatInstance.Fn_Event_LinkHistoryTransfer = () => null;

      this.chatInstance.ChatRequestId = (this.props.validationResult.chatRequestId || this.props.validationResult.chatRequestID).toString();
      if (this.props.connectionId) {
        this.chatInstance.ReopenId = this.props.connectionId.toString();
      }

      let startResult = this.chatInstance.Init();

      if (startResult !== 'SUCCESS') {
        this.props.onInitError(startResult);
        return;
      }

      this.chatInstance.StartHub();
    }
  }
  initializeBotInstance() {
    var saidHello = false;
    let { props } = this,
        { conversation, started, ended } = props.botState;

    if (started && !ended && !this.botInstance) {
      this.botInstance = new DirectLine({
        ...conversation,
        pollingInterval: props.botConfiguration.pollingInterval
      });
      this.botInstance.postActivity({
        from: { id: this.props.botState.userId, name: this.props.client.userRenderHeader },
        type: 'userConnected',
        text: this.props.botState.caseComments,
      }).subscribe(props.onBotActivityPublished, props.onBotError);
      this.botInstance.activity$
        .subscribe(activity => {
          this.props.onBotActivityReceived(activity);
          if (activity.type === 'message' && activity.from.id !== props.botState.userId.toString()) {
            this.lastNotification = this.props.onMessageReceived(
              this.receivedMessageOptions, activity.text, activity.from.name
            ).notification
          } else if (activity.type === 'transferToAgent') {
            props.onBotEnd();
            props.onStartHub(activity.channelData);
          }
        });
      this.botInstance.connectionStatus$
        .subscribe(status => {
          props.onBotStatusChanged(status);
          switch (status) {
            case ConnectionStatus.ExpiredToken:
              directLine.reconnect(conversation);
              break;
            case ConnectionStatus.FailedToConnect:
              props.onBotEnd();
              break;
            case ConnectionStatus.Ended:
              props.onBotEnd();
              break;
          }
        });
    }
  }
  encryptSymmetricKey(data) {
    fnInitKey();
    return encryptedString(rsakeyTPCOL, Base64.encode(data));
  }
  encryptMessageHub(data, symmetrickey) {
    return CryptoJS.AES.encrypt(data,
      CryptoJS.enc.Hex.parse(symmetrickey.split('^')[0]),
      { iv: CryptoJS.enc.Hex.parse(symmetrickey.split('^')[1]) }
    ).toString();
  }
  decryptMessageHub(data, symmetrickey) {
    return CryptoJS.enc.Utf8.stringify(
      CryptoJS.AES.decrypt(data,
        CryptoJS.enc.Hex.parse(symmetrickey.split('^')[0]),
        { iv: CryptoJS.enc.Hex.parse(symmetrickey.split('^')[1]) }
      )
    );
  }

  componentDidMount() {
    if (this.checkIfOutOfSchedule()) {
      return;
    }
    this.initializeBotInstance();
    this.initializeChatInstance();
  }
  componentWillReceiveProps(nextProps) {
    this.initializeChatInstance();
    this.initializeBotInstance();

    if (!nextProps.minimized && this.props.minimized) {
      this.focused();
    }
  }
  get padding() {
    if (!this.props.chatting && !this.props.ended) {
      return ChatMain.PADDING;
    } else {
      return 0;
    }
  }
  get rederingMainWraper() {
    if (this.props.fullscreen) {
      return {
        height: this.props.appHeight - this.padding + 'px',
        padding: this.padding + 'px',
      };
    }
  }

  sendMessageToAgent(message) {
    return this.chatInstance.UserSendMessage(message, this.props.client.userRenderHeader, this.props.client.name);
  }

  renderMain() {
    let onEnd = () => {
      if (this.props.hubStarted) {
        this.chatInstance.UserEndChat();
        this.props.onChatEnd(CHAT_PART.customer, this.props.surveyTextHeader);
      } else {
        this.botInstance.postActivity({
          from: { id: this.props.botState.userId, name: this.props.client.userRenderHeader },
          type: 'endOfConversation'
        }).subscribe(this.props.onStartHub, this.props.onStartHub);
      }
    };

    if (this.props.hubStarted && this.props.validationResult.isOutOfSchedule) {
      return <Schedule />;
    }

    if (this.props.routing || this.state.reconnecting || this.state.reconnectingFailed) {
      return (
        <SearchingForAgent 
          reconnectingFailed={this.state.reconnectingFailed}
          reconnecting={this.state.reconnecting} 
          onAbort={this.chatInstance.fnAbortRoutingChat} 
        />
      );
    }

    if ((this.props.started && this.props.chatting) || this.props.ended) {
      if (this.state.restartingBecauseOfDiscconect || (this.props.ended && this.props.thankAndReload)) {
        return <Thanks label={this.state.restartingBecauseOfDiscconect ? 'Hubo un error de conexión, reiniciando' : undefined} />;
      }

      return (
        <Chat 
          ref={c => this.chat = c}
          appWidth={this.props.appWidth} 
          fullscreen={this.props.fullscreen}
          hideSendButton={false}
          onMinimize={this.props.onMinimize}
          onSendMessage={this.props.hubStarted
            ? message => this.sendMessageToAgent(message)
            : message => {
              this.botInstance.postActivity({
                from: { id: this.props.botState.userId, name: this.props.client.userRenderHeader },
                type: 'message',
                text: message
              }).subscribe(this.props.onBotActivityPublished, this.props.onBotError);
              this.props.onMessageSent(message, this.props.client.userRenderHeader);
            }
          }
          onEnd={onEnd}
          onUserTyping={
            this.chatInstance ? () => {
              this.chatInstance.UserIsTyping();
              this.props.onUserTyping();
            } : undefined
          }
          onUserNotTyping={
            this.chatInstance ? () => {
              this.chatInstance.UserNoTyping();
              this.props.onUserNotTyping();
            } : undefined
          }
          onSendMailTranscript={() => {
            this.chatInstance.RequestChatTranscriptByMail();
            this.props.onSendMailTranscript();
          }}
          onStartWebRTCInternal={() => {
            this.chatInstance.StartVideo();
          }}
          headerHeight={this.props.headerHeight}
          appHeight={this.props.appHeight}
          onEndWebRTC={() => {
            this.chatInstance.EndVideo();
            this.props.onEndWebRTC();
            if (this.props.endAfterVideoClosed) {
              onEnd();
            }
          }}
          sendDisabled={this.props.botState.ended && !this.props.hubStartedTime}
        />
      );
    }
  }
  render() {
    let mainWraperClassname = 'chat-main-wraper'
        + (this.props.fullscreen ? ' fullscreen' : '')
        + (this.props.ended ? ' ended' : '');

    return (
      <div className={mainWraperClassname} style={this.rederingMainWraper}>
        { this.loading() }
        { this.state.reconnecting ? undefined : this.error() }
        { this.renderMain() }
      </div>
    );
  }
}

export default ChatMain;



// WEBPACK FOOTER //
// ./components/chat/index.js